import styled, { css } from "styled-components";

export const Container = styled.div`
  width: 100%;
  display: flex;
  padding: 0 140px;

  flex-direction: ${({ main }) => main === "true" && "column"};
  justify-content: space-evenly;
  background: var(--light-bg-color);
  padding: ${({ main }) => main === "true" && "92px 0 100px 0"};
`;

export const BlogWrapper = styled(Container)`
  flex-wrap: wrap;
`;
export const Wrapper = styled.div`
  text-align: center;
  margin-bottom: 50px;
`;
const titleStyle = css`
  line-height: 38px;
  font-style: normal;
  font-weight: 600;
  color: #0d263b;
  font-size: 30px;
  margin-bottom: 10px;
`;
const Desc = css`
  line-height: 20px;
  font-style: normal;
  font-weight: normal;
  color: #696969;
  font-size: 16px;
  margin: 10px 0 32px 0;
`;
export const Title = styled.div`
  ${({ title }) => title === "true" && titleStyle};
  ${({ desc }) => desc === "true" && Desc};
`;
